import React, { useEffect } from 'react';
import Hightlight from '../Component/Hightlight' 
import { useLocation, NavLink ,Link } from 'react-router-dom'; 
import jQuery from 'jquery';
import LazyLoad from 'react-lazyload';

const Header = () => {
   const { pathname } = useLocation(); 
   useEffect(() => {
     window.scrollTo(0, 0);
   }, [pathname]);
   useEffect(() => {
      // jQuery code for menu initialization
      (function (jQuery) {
         jQuery.fn.menumaker = function (options) {
            var cssmenu = jQuery(this), settings = jQuery.extend({
               format: 'dropdown',
               sticky: false,
            },
               options);
            return this.each(function () {
               jQuery(this)
                  .find('.menubutton')
                  .on('click', function () {

                     jQuery(this).toggleClass('menu-opened');
                     var mainmenu = jQuery(this).next('ul');
                     if (mainmenu.hasClass('open')) {
                        mainmenu.slideToggle().removeClass('open');
                     } else {
                        mainmenu.addClass('open');
                        if (settings.format === 'dropdown') {
                           mainmenu.find('ul').show();
                        }
                     }
                  });
               cssmenu.find('li ul').parent().addClass('has-sub');
               var multiTg = function () {
                  cssmenu.find('.has-sub').append('<span class="submenu-button"></span>');
                  cssmenu.find('.submenu-button').on('click', function () {
                     jQuery(this).toggleClass('submenu-opened');
                     if (jQuery(this).siblings('ul').hasClass('open')) {
                        jQuery(this).siblings('ul').removeClass('open').slideToggle();
                     } else {
                        jQuery(this).siblings('ul').addClass('open').slideToggle();
                     }
                  });
               };
               if (settings.format === 'multitoggle') multiTg();
               else cssmenu.addClass('dropdown');
               if (settings.sticky === true) cssmenu.css('position', 'fixed');
               var resizeFix = function () {
                  var mediasize = 1217;
                  if (jQuery(window).width() > mediasize) {
                     cssmenu.find('ul').show();
                  }
                  if (jQuery(window).width() <= mediasize) {
                     cssmenu.find('ul').hide().removeClass('open');
                  }
               };
               resizeFix();
               return jQuery(window).on('resize', resizeFix);
            });
         };
      })(jQuery);
      jQuery(document).ready(function () {
         jQuery("#cssmenu").menumaker({
            format: "multitoggle"
         });
      });
   }, []); // Empty dependency array to ensure the effect runs only once on mount

   return (
      <section className="top-header multbg">
         <div className="container-fluid">
            <div className="row">
               <div className="col-lg-3 col-md-12">
                  <div className="logo">
                     <Link to="/"><LazyLoad> <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/logo.png" className="img-fluid mx-auto d-block" alt="Sacred Heart School Balia" /></LazyLoad></Link>
                  </div>
               </div>
               <div className="col-lg-9 col-md-12 menu-p-0">
                  <div className="row">
                     <div className="col-md-12">
                        <div className="topbar">
                           <div className="col-md-12">
                              <Hightlight />
                           </div>
                        </div>
                     </div>
                     <div className="col-md-12">
                        <header>
                           <div className="header-menu navigation">
                              <nav id="cssmenu">
                                 <div id="head-mobile"></div>
                                 <div className="menubutton"></div>
                                 <ul>
                                    <li><Link to="/">Home</Link></li>
                                    <li>
                                       <Link to="#">About </Link>
                                       <ul>
                                          <li><NavLink to="/About">General Information</NavLink></li>
                                          <li><NavLink to="/GeneralRules">General Rule</NavLink></li>
                                          <li><NavLink to="/Mission">Mission</NavLink></li>
                                          <li><NavLink to="/Vision">Vision</NavLink></li>
                                          <li><NavLink to="/Motto">Motto</NavLink></li>
                                       </ul>
                                    </li>
                                    <li>
                                       <Link to="#">Admission</Link>
                                       <ul>
                                          <li><NavLink to="/AdmissionProcess">Admission Process </NavLink></li>
                                          <li><NavLink to="/AdmissionGuidelines">Admission Guidelines </NavLink></li>
                                          <li><NavLink to="/RegistrationForm">Registration Form</NavLink></li>
                                          <li><NavLink to="/Discipline">Importance Of Discipline </NavLink></li>
                                          <li><NavLink to="/Withdrawal">Withdrawal Process </NavLink></li>
                                          <li><NavLink to="/SchoolFee">School Fee </NavLink></li>
                                       </ul>
                                    </li>
                                    <li>
                                       <Link to="#">Academic</Link>
                                       <ul>
                                          <li><NavLink to="/AcademicEthos">Academic Ethos</NavLink></li>
                                          <li><NavLink to="/Facilities">Facilities</NavLink></li>
                                          <li><NavLink to="/FeeStructure">Fee Structure</NavLink></li>
                                          <li><NavLink to="/Faculty">Faculty </NavLink></li>
                                          <li><NavLink to="https://webapi.entab.info/api/image/SHSSB/public/pdf/Session-Calendar.pdf" target="_blank">New Session Calendar 2024-25</NavLink></li> 
                                       </ul>
                                    </li>
                                    <li>
                                       <Link to="#">Activities  </Link>
                                       <ul>
                                          <li><NavLink to="/Clubs">Clubs</NavLink></li>
                                          <li><NavLink to="/Supw">Supw</NavLink></li>
                                          <li><NavLink to="/Sports">Sports</NavLink></li> 
                                       </ul>
                                    </li>
                                    <li>
                                       <Link to="#">Gallery</Link>
                                       <ul>
                                          <li><NavLink to="/Gallery">Photo Gallery</NavLink></li> 
                                          <li><NavLink to="/Activities">Activities</NavLink></li>
                                          <li><NavLink to="/Exhibitions">Exhibitions</NavLink></li>
                                          <li><NavLink to="/VideoGallery">Video Gallery</NavLink></li>
                                       </ul>
                                    </li>
                                    <li>
                                       <Link to="#">News</Link>
                                       <ul>
                                          <li><NavLink to="/Examination">Examination</NavLink></li>
                                          <li><NavLink to="/News">General Notice</NavLink></li> 
                                          <li><NavLink to="/Events">Events</NavLink></li> 
                                       </ul>
                                    </li>
                                    <li><Link to="#">Login/Register</Link>
                                       <ul>
                                          <li><NavLink to="https://shsb.campussoft.net/" target="_blank">Parents/Students Login</NavLink></li>
                                          <li><NavLink to="https://shsb.campussoft.net/" target="_blank">Teachers Login</NavLink></li>
                                          <li><NavLink to="https://shsb.campussoft.net/" target="_blank">Principal Login</NavLink></li>
                                          <li><NavLink to="https://shsb.campussoft.net/" target="_blank">Online Exam</NavLink></li>
                                       </ul>
                                    </li> 
                                 </ul>
                              </nav>
                           </div> 
                        </header>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}

export default Header;
